import landing from "./fa/landing";
import auth from "./fa/auth";
import profile from "./fa/profile";
import checkout from "./fa/checkout";

export default {
  // New UI copy for the redesign, one file per area.
  ui: { landing, auth, profile, checkout },
  title: "خرید اشتراک ویژه فونتا، فونت استوری برای اینستاگرام",
  description: "حذف تبلیغات و امکانات ویژه با خرید اشتراک پرو فونتا. همین حالا ارتقا دهید و تجربه‌ای بی‌نظیر از فونتا برای اینستاگرام داشته باشید.",
  og: {
    title: "خرید اشتراک ویژه فونتا، فونت استوری برای اینستاگرام",
    description: "حذف تبلیغات و امکانات ویژه با خرید اشتراک پرو فونتا. همین حالا ارتقا دهید و تجربه‌ای بی‌نظیر از فونتا برای اینستاگرام داشته باشید.",
    site_name: "فونتا",
  },
  subscribe: {
    price: "{{price, toCurrency, renderDigits}} {{currency.symbol}}",
  },
  pagination: {
    previous: "قبلی",
    next: "بعدی",
  },
  errors: {
    emailAddressAlreadyTaken: "ایمیل قبلاً استفاده شده است",
    mobileAlreadyTaken: "شماره موبایل قبلاً استفاده شده است",
    "number.base": "لطفاً یک عدد وارد کنید",
    "number.empty": "این فیلد نمی‌تواند خالی باشد",
    "any.required": "این فیلد الزامی است",
    "any.only": "مقدار وارد شده مجاز نیست",
    "string.base": "لطفاً این فیلد را پر کنید",
    "string.empty": "این فیلد نمی‌تواند خالی باشد",
    "string.email": "لطفاً آدرس ایمیل را به صورت صحیح وارد کنید",
    "string.min": "حداقل طول این فیلد ۸ کاراکتر است",
    "string.pattern.base": "فرمت وارد شده صحیح نیست",
    "0": "اتصال اینترنت وجود ندارد",
    "0_message": "مشکلی در اتصال به اینترنت وجود داشت، لطفاً دوباره تلاش کنید",
    "401": "عدم اعتبار",
    "401_message": "شما مجوز دسترسی به این بخش را ندارید، لطفاً با مدیر سایت تماس بگیرید",
    "500": "خطای اتصال",
    "500_message": "مشکلی در اتصال به اینترنت وجود دارد، لطفاً دوباره تلاش کنید",
    "404": "پیدا نشد",
    "404_message": "آیا گم شده‌اید؟ برای رفتن به خانه دکمه زیر را کلیک کنید",
    "409": "توکن منقضی شده",
    "409_message": "توکن اخیر شما منقضی شده است، لطفاً صفحه را مجدداً بارگذاری کنید و با معامله ادامه دهید",
    "429": "تعداد درخواست‌ها بیش از حد مجاز است",
    "429_message": "تعداد درخواست‌ها بیش از حد مجاز است، لطفاً بعد از {{seconds}} ثانیه دوباره تلاش کنید",
  },
  profile: "پروفایل",
  name: "اسم",
  edit: "ویرایش",
  verified: "تایید شده",
  notVerified: "تایید نشده",
  status: "وضعیت",
  resendVerificationLink: "ارسال مجدد لینک تایید",
  dangerZone: "منطقه خطر",
  deleteAccount: "حذف اکانت",
  backToHome: "بازگشت به خانه",
  wait: "لطفاً صبر کنید",
  reload: "تلاش دوباره",
  forgotPassword: "فراموشی رمز",
  revoke: "حذف",
  email: "ایمیل",
  activeSessions: "نشست‌های فعال",
  noOtherActiveSessions: "هیچ نشست فعال دیگری وجود ندارد",
  getProNow: "همین حالا پرو شوید",
  noPurchasesYet: "شما هنوز خریدی انجام نداده‌اید. برای استفاده از امکانات ویژه، اشتراک پرو تهیه کنید.",
  noProYet: "هنوز پرو نیستید",
  history: "تاریخچه",
  back: "بازگشت",
  support: "پشتیبانی",
  receipts: "اشتراک‌ها",
  logout: "خروج",
  invoices: "فاکتورها",
  language: "زبان",
  currency: "واحد پول",
  currencies: "واحدهای پولی",
  settings: "تنظیمات",
  myReceipts: "اشتراک‌های من",
  manageAccount: "مدیریت حساب",
  youArePro: "شما پرو هستید",
  upgradeToPro: "ارتقا به پرو",
  subscriptionStatus: "وضعیت اشتراک",
  activeUntil: "فعال تا {{days, renderDigits}} روز دیگر",
  renewSubscription: "تمدید اشتراک",
  myDevices: "دستگاه‌های من",
  devices: "دستگاه‌ها",
  myInvoices: "خرید‌های من",
  amount: "{{amount, renderDigits}} {{currency.symbol}}",

  invoice: {
    pending: "در انتظار بررسی",
    paid: "پرداخت شده",
    failed: "ناموفق",
    canceled: "لغو شده",
    refunded_with_revoke: "بازپرداخت شده با لغو",
    refunded_with_fraud_revoke: "بازپرداخت شده با لغو به دلیل تقلب",
  },
  receipt: {
    available: "فعالسازی",
    consumed: "تمدید اشتراک",
    unavailable: "اشتراک اتمام رسیده",
  },
  plan: {
    bronze: "۱ ماهه",
    silver: "۳ ماهه",
    gold: "۶ ماهه",
    platinum: "۱۲ ماهه",
  },
  login: "ورود",
  register: "ثبت‌نام",
  auth: {
    alreadyHaveAccount: "قبلاً ثبت نام کرده‌اید؟",
    notHaveAccount: "هنوز ثبت نام نکرده‌اید؟",
    forgotYourPassword: "رمز عبور خود را فراوش کرده‌اید؟",
    registerNow: "همین حالا ثبت نام کنید",
    loginToHidSim: "ورود به هیدسیم",
    registerToHidSim: "ثبت نام در هیدسیم",
    enterYourCredentials: "اطلاعات خود را وارد کنید",
    backToHome: "بازگشت به خانه",
    byRegisteringYouAgreeToOurTermsOfService: `با ثبت نام شما با <2>قوانین استفاده</2> و <6>محرمانگی</6> سرویس موافقت کرده‌اید.`,
    login: {
      "mobile.number": "شماره موبایل",
      password: "رمز عبور",
      "email.address": "آدرس ایمیل",
      invalid: "شماره/ایمیل یا رمز عبور نامعتبر است",
      locked: "حساب شما به‌عنوان پرخطر علامت‌گذاری شده و دسترسی موقتاً محدود شده است. لطفاً برای دریافت راهنمایی بیشتر با پشتیبانی تماس بگیرید.",
    },
    register: {
      "mobile.number": "شماره موبایل",
      "email.address": "آدرس ایمیل",
      password: {
        hash: "رمز عبور",
        confirmation: "تأیید رمز عبور",
      },
      profile: {
        name: {
          first: "نام",
          last: "نام خانوادگی",
        },
      },
    },
    forgot: {
      title: "فراموشی رمز عبور",
      subtitle: "در صورت فراموشی رمز عبور خود میتوانید برای بازیابی آن در اینستاگرام با ما در ارتباط باشید",
    },
  },

  charge: {
    choosePaymentMethod: "روش پرداخت را انتخاب کنید",
    payWithCrypto: "پرداخت با کریپتو",
    payWithCreditCard: "پرداخت با ویزا و مستر",
    payWithPaypal: "پرداخت با پی‌پال",
    payOffline: "پرداخت آفلاین",
    payOfflineSubtitle: "به صورت کارت به کارت یا واریز به حساب بانکی عملیات پرداخت را انجام دهید",
    payWithIrLocalGateway: "پرداخت از طریق درگاه بانکی",
    payWithIrLocalGatewaySubtitle: "حساب خود را به‌راحتی با کارت‌های شتاب شارژ کنید.",
    payWithCryptoSubtitle: "با استفاده از رمزارزهایی مانند بیت‌کوین، تتر و سایر ارزهای دیجیتال، حساب خود را شارژ کنید.",
    payWithCreditCardSubtitle: "اگر عجله دارید، پیشنهاد می‌کنیم از روش‌های پرداخت جایگزین مانند ارز دیجیتال استفاده کنید.",
    payWithIap: "پرداخت با خرید درون‌برنامه‌ای",
    payWithIapSubtitle:
      "شما می‌توانید با خرید درون‌برنامه‌ای در دستگاه‌های iOS و Android پرداخت کنید. این روش فقط برای کاربرانی که اپلیکیشن هیدسیم را نصب کرده‌اند در دسترس است.",
    mostPopular: "پرطرفدار",
    continueToPayment: "ادامه به پرداخت",
    submitBtn: "<0>خرید </0><1>{{name}}</1><2> با </2><3><0>{{symbol}}</0><1>{{price}}</1></3>",
    registerDepositRequest: "ثبت درخواست واریز",
    notAcceptable: "این روش پرداخت با توجه به واحد پولی شما در دسترس نیست، لطفا ابتدا واحد پولی خود را تغییر دهید و مجددا تلاش کنید.",
    submitting: "لطفا صبر کنید",
    iapSubmitting: "منتظر باز شدن پنجره IAP باشید...",
    selectPackage: "ابتدا بسته را انتخاب کنید",
    selectGateway: "ابتدا درگاه را انتخاب کنید",
    policy: "<0><0>با خرید این بسته، شما با </0><1>شرایط </1><2>استفاده و </2><3>سیاست حفظ حریم خصوصی</3><0> هیدسیم موافقت می‌کنید.</0>",
    inviteFriendsEarnMoney: "دوستان خود را دعوت کنید، کسب درآمد کنید",
    inviteFriendsEarnMoneySubtitle: "دوستان خود را به هیدسیم دعوت کنید و برای هر خرید موفقی که انجام می‌دهند، هدیه دریافت کنید.",
    noAvailablePackages: "بسته‌های قابل خرید برای شما وجود ندارد",
    contactSupport: "برای دریافت کمک بیشتر با پشتیبانی تماس بگیرید.",
    uploadReceipt: "رسید خود را آپلود کنید",
    notAvailableInYourRegion: "این روش پرداخت در منطقه شما در دسترس نیست، در صورت استفاده از VPN لطفا آن را غیرفعال کنید و مجدداً تلاش کنید.",
  },
  modals: {
    revokeConfirmation: {
      title: "آیا مطمئنید؟",
      browser: "مرورگر",
      os: "سیستم عامل",
      country: "کشور",
      ip: "آی‌پی",
      discard: "بیخیال",
      pleaseWait: "لطفاً صبر کنید",
      revoke: "حذف",
    },
    editUserProfile: {
      profile: "پروفایل",
      editYourProfile: "اطلاعات پروفایل خود را ویرایش کنید و برای ذخیره تغییرات دکمه ذخیره را بزنید.",
      saveChanges: "ذخیره تغییرات",
      firstNameLabel: "نام",
      lastNameLabel: "نام خانوادگی",
      firstNamePlaceholder: "نام خود را وارد کنید",
      lastNamePlaceholder: "نام خانوادگی خود را وارد کنید",
      successMessage: "پروفایل با موفقیت به‌روزرسانی شد!",
      closeButton: "بستن",
    },
    editEmail: {
      email: "ایمیل",
      editYourEmail: "آدرس ایمیل خود را ویرایش کنید و برای ذخیره تغییرات دکمه ذخیره را بزنید.",
      saveChanges: "ذخیره تغییرات",
      emailPlaceholder: "آدرس ایمیل خود را وارد کنید",
      successMessage: "ایمیل با موفقیت به‌روزرسانی شد!",
      closeButton: "بستن",
    },
    deleteUserConfirmation: {
      deleteAccount: "حذف اکانت",
      areYouSure: "آیا مطمئنید که می‌خواهید اکانت خود را حذف کنید؟ این عملیات غیرقابل بازگشت است.",
      delete: "حذف",
      pleaseWait: "لطفاً صبر کنید",
      discard: "بستن",
    },
  },
};
